const serializeProperty = property => (
    `${property.groupName}>${property.name}>${property.value}`
)

export default serializeProperty
